const getValuePair = (value: string, start: number, end: number) =>
  parseInt(value.substring(start, end), 16);

const HexToRgb = (hex: string) => {
  const rgbValues = hex.replace('#', '');
  const red = getValuePair(rgbValues, 0, 2);
  const green = getValuePair(rgbValues, 2, 4);
  const blue = getValuePair(rgbValues, 4, 6);
  const rgbValue = `${red}, ${green}, ${blue}`;

  return rgbValue;
};

export default HexToRgb;
